<div class="row">
    <div [ngClass]="isAdd ? 'col-sm-6' : 'col-sm-10'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageable]="false"
                    [sortable]="false"
                    [filterable]="false"
                    [resizable]="true"
                    [style.maxHeight.px]="400"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem)"><i class="fas fa-pencil-alt"></i></button>
                    <!--<button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.employeeGroupMapID)"><i class="fas fa-times"></i></button>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="fuelRateTierID" title="ID"></kendo-grid-column>
            <kendo-grid-column field="sequence" title="Sequence"></kendo-grid-column>
            <kendo-grid-column field="minValue" title="Min Value"></kendo-grid-column>
            <kendo-grid-column field="maxValue" title="Max Value"></kendo-grid-column>
            <kendo-grid-column field="charge" title="Charge"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-2" *ngIf="!isAdd">
        <button class="btn btn-sml btn-secondary" title="Close" tabindex="-1" (click)="close()" *ngIf="!isAdd"><i class="fas fa-times"></i></button>
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isAdd || isEdit">
        <div class="row">
            <div class="col">
                <label class="fw-bold">Sequence</label>
                <input type="number" class="form-control" [(ngModel)]="tableItem.sequence" min="1" step="1" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Min Value</label>
                <kendo-numerictextbox class="form-control" [(ngModel)]="tableItem.minValue" [format]="'n3'" [decimals]="3" [min]="minValue" [max]="tableItem.maxValue" [autoCorrect]="true" required></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Max Value</label>
                <kendo-numerictextbox class="form-control" [(ngModel)]="tableItem.maxValue" [format]="'n3'" [decimals]="3" [min]="tableItem.minValue" [max]="maxValue" [autoCorrect]="true" required></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Charge</label>
                <kendo-numerictextbox type="number" class="form-control" [(ngModel)]="tableItem.charge" [format]="'n2'" [decimals]="2" [min]="0.00" required></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
